// eslint-disable-next-line
export default (products = [], action) => {
	switch (action.type){
		case 'FETCH_ALL':
			return products;
		default:
			return products;
	}
}